(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-shelves"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var lanes = [];
    var state = { cat: '__all', rars: [], lo: null, hi: null };

    function gridEl() { return document.getElementById('product-grid-container'); }
    function closeMenus() { document.querySelectorAll('[data-bxc-sortmenu], [data-bxc-switchmenu]').forEach(function (m) { m.hidden = true; }); }
    function openSide() { var s = document.querySelector('[data-bxc-side]'); var b = document.querySelector('[data-bxc-sidebackdrop]'); if (s) s.classList.add('is-open'); if (b) b.hidden = false; document.body.classList.add('bxc-noscroll'); }
    function closeSide() { var s = document.querySelector('[data-bxc-side]'); var b = document.querySelector('[data-bxc-sidebackdrop]'); if (s) s.classList.remove('is-open'); if (b) b.hidden = true; document.body.classList.remove('bxc-noscroll'); }
    function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }
    function toggleFilter() { if (isMobile()) { openSide(); } else { var lay = document.querySelector('.bxc-layout'); if (lay) lay.classList.toggle('is-side-collapsed'); } }
    function scrollToTop() { var sec = document.querySelector('.bxc'); if (sec) window.scrollTo({ top: sec.offsetTop - 16, behavior: 'smooth' }); }

    /* Move viewport-fixed elements out of #MainContent onto <body>. A transformed
       ancestor (page transitions, animations) becomes the containing block for
       position:fixed and would pin the nav to the page instead of the screen. */
    function hoist(sel) {
      var els = Array.prototype.slice.call(document.querySelectorAll(sel));
      if (!els.length) return;
      var keep = null;
      els.forEach(function (el) { if (!el.hasAttribute('data-bxc-moved')) keep = el; });
      if (!keep) keep = els[0];
      els.forEach(function (el) { if (el !== keep && el.parentNode) el.parentNode.removeChild(el); });
      keep.setAttribute('data-bxc-moved', '1');
      if (keep.parentNode !== document.body) document.body.appendChild(keep);
    }

    function cardMatches(card) {
      if (state.rars.length) { var rar = card.getAttribute('data-rarity') || ''; if (state.rars.indexOf(rar) === -1) return false; }
      var price = parseFloat(card.getAttribute('data-price')) / 100;
      if (!isNaN(price)) { if (state.lo !== null && price < state.lo) return false; if (state.hi !== null && price > state.hi) return false; }
      return true;
    }

    /* ============ TWO-VIEW BUCKET RENDER: wipe first, then inject fresh ============ */
    function updateProductGrid() {
      var c = gridEl(); if (!c) return;
      c.innerHTML = '';
      var shown = 0;
      if (state.cat === '__all') {
        c.classList.remove('is-flat');
        lanes.forEach(function (L) {
          L.row.innerHTML = '';
          var vis = 0;
          L.cards.forEach(function (card) {
            if (cardMatches(card)) { card.style.display = ''; vis++; } else { card.style.display = 'none'; }
            L.row.appendChild(card);
          });
          L.el.style.display = vis ? '' : 'none';
          shown += vis;
          c.appendChild(L.el);
        });
      } else {
        c.classList.add('is-flat');
        lanes.forEach(function (L) {
          if (L.word !== state.cat) return;
          L.cards.forEach(function (card) {
            if (cardMatches(card)) { card.style.display = ''; c.appendChild(card); shown++; }
          });
        });
      }
      var empty = document.querySelector('[data-bxc-empty]'); if (empty) empty.classList.toggle('is-shown', shown === 0);
    }

    /* ============ UNIFIED CATEGORY FILTER — pills, bottom nav, and عرض الكل ============ */
    function filterCategory(categoryName) {
      state.cat = categoryName;
      document.querySelectorAll('[data-bxc-filter]').forEach(function (x) {
        var on = x.getAttribute('data-bxc-filter') === categoryName;
        if (x.classList.contains('bxc-shelf__all')) { x.classList.remove('is-active'); return; }
        x.classList.toggle('is-active', on);
        if (on) { var bar = x.closest('.bxc-catnav__inner, .bxc-bottomnav'); if (bar && bar.scrollTo) { bar.scrollTo({ left: x.offsetLeft - bar.clientWidth / 2 + x.clientWidth / 2, behavior: 'smooth' }); } }
      });
      updateProductGrid();
      closeSide();
      scrollToTop();
    }

    function initRange() {
      var wrap = document.querySelector('[data-bxc-range]'); if (!wrap || wrap.dataset.bound) return; wrap.dataset.bound = '1';
      var min = parseFloat(wrap.getAttribute('data-min')) || 0; var max = parseFloat(wrap.getAttribute('data-max')) || 0;
      var rmin = wrap.querySelector('[data-bxc-rmin]'); var rmax = wrap.querySelector('[data-bxc-rmax]'); var fill = wrap.querySelector('[data-bxc-fill]');
      var nmin = document.querySelector('[data-bxc-nmin]'); var nmax = document.querySelector('[data-bxc-nmax]');
      function clamp(val) { if (isNaN(val)) val = min; if (val < min) val = min; if (val > max) val = max; return val; }
      function upd() {
        var a = parseFloat(rmin.value); var b = parseFloat(rmax.value); if (a > b) { var t = a; a = b; b = t; }
        var span = (max - min) || 1; var p1 = ((a - min) / span) * 100; var p2 = ((b - min) / span) * 100;
        if (fill) { fill.style.left = p1 + '%'; fill.style.right = (100 - p2) + '%'; }
        if (nmin && document.activeElement !== nmin) nmin.value = Math.round(a);
        if (nmax && document.activeElement !== nmax) nmax.value = Math.round(b);
        state.lo = a; state.hi = b;
      }
      rmin.addEventListener('input', function () { if (parseFloat(rmin.value) > parseFloat(rmax.value)) rmin.value = rmax.value; upd(); updateProductGrid(); });
      rmax.addEventListener('input', function () { if (parseFloat(rmax.value) < parseFloat(rmin.value)) rmax.value = rmin.value; upd(); updateProductGrid(); });
      if (nmin) nmin.addEventListener('change', function () { var val = clamp(parseFloat(nmin.value)); if (val > parseFloat(rmax.value)) val = parseFloat(rmax.value); rmin.value = val; upd(); updateProductGrid(); });
      if (nmax) nmax.addEventListener('change', function () { var val = clamp(parseFloat(nmax.value)); if (val < parseFloat(rmin.value)) val = parseFloat(rmin.value); rmax.value = val; upd(); updateProductGrid(); });
      upd();
    }
    function resetFilters() {
      document.querySelectorAll('.bxc-rar.is-on').forEach(function (p) { p.classList.remove('is-on'); });
      state.rars = [];
      var wrap = document.querySelector('[data-bxc-range]');
      if (wrap) { var rmin = wrap.querySelector('[data-bxc-rmin]'); var rmax = wrap.querySelector('[data-bxc-rmax]'); rmin.value = rmin.min; rmax.value = rmax.max; rmin.dispatchEvent(new Event('input')); rmax.dispatchEvent(new Event('input')); }
      else { updateProductGrid(); }
    }
    function findCartIcon() { return document.querySelector('#cart-icon-bubble') || document.querySelector('a[href$="/cart"]') || document.querySelector('a[href*="/cart"]') || document.querySelector('[data-cart-icon]'); }
    function floatPlusOne() {
      var icon = findCartIcon(); var el = document.createElement('div'); el.className = 'bxc-plusone'; el.textContent = '+1'; document.body.appendChild(el);
      if (icon) { var r = icon.getBoundingClientRect(); el.style.left = (r.left + r.width / 2) + 'px'; el.style.top = (r.top + 4) + 'px'; } else { el.style.left = '50%'; el.style.top = '76px'; }
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-go'); }); });
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 900);
    }
    document.addEventListener('click', function (e) {
      var so = e.target.closest('[data-bxc-sortbtn]');
      if (so) { var m = so.parentNode.querySelector('[data-bxc-sortmenu]'); var was = m.hidden; closeMenus(); m.hidden = !was; e.stopPropagation(); return; }
      var sb = e.target.closest('[data-bxc-switchbtn]');
      if (sb) { var m2 = sb.parentNode.querySelector('[data-bxc-switchmenu]'); var was2 = m2.hidden; closeMenus(); m2.hidden = !was2; e.stopPropagation(); return; }
      if (e.target.closest('[data-bxc-toggle-filter]')) { toggleFilter(); closeMenus(); return; }
      if (e.target.closest('[data-bxc-closeside]')) { closeSide(); return; }
      if (e.target.closest('[data-bxc-resetfilters]')) { resetFilters(); return; }
      if (e.target.closest('[data-bxc-applyfilters]')) { closeSide(); return; }
      var gm = e.target.closest('[data-bxc-gamesmore]');
      if (gm) { var grid = document.querySelector('[data-bxc-games]'); var lbl = gm.querySelector('[data-bxc-gamesmore-lbl]'); if (grid) { grid.classList.toggle('is-collapsed'); gm.classList.toggle('is-open'); if (lbl) lbl.textContent = grid.classList.contains('is-collapsed') ? 'عرض أكثر' : 'عرض أقل'; } return; }
      var rp = e.target.closest('[data-bxc-rar]');
      if (rp) { rp.classList.toggle('is-on'); state.rars = []; document.querySelectorAll('.bxc-rar.is-on').forEach(function (p) { state.rars.push(p.getAttribute('data-bxc-rar')); }); updateProductGrid(); return; }
      var addBtn = e.target.closest('[data-bxc-add]');
      if (addBtn && !addBtn.disabled) {
        e.preventDefault(); var aid = addBtn.getAttribute('data-vid'); if (!aid) return;
        if (addBtn.classList.contains('is-loading') || addBtn.classList.contains('is-done')) return;
        addBtn.classList.add('is-pop'); setTimeout(function () { addBtn.classList.remove('is-pop'); }, 360);
        addBtn.classList.add('is-loading');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(aid, 10), quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { addBtn.classList.remove('is-loading'); addBtn.classList.add('is-done'); floatPlusOne(); document.dispatchEvent(new CustomEvent('bxc:cart-updated')); setTimeout(function () { addBtn.classList.remove('is-done'); }, 1000); })
          .catch(function () { addBtn.classList.remove('is-loading'); });
        return;
      }
      var f = e.target.closest('[data-bxc-filter]');
      if (f) { e.preventDefault(); filterCategory(f.getAttribute('data-bxc-filter')); return; }
      var s = e.target.closest('[data-bxc-scroll]');
      if (s) { var scr = s.closest('.bxc-shelf__scroller'); var row = scr && scr.querySelector('[data-bxc-row]'); if (row) { var dir = parseInt(s.getAttribute('data-bxc-scroll'), 10) || 1; row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: 'smooth' }); } return; }
      if (!e.target.closest('[data-bxc-sortmenu], [data-bxc-switchmenu]')) closeMenus();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMenus(); closeSide(); } });
    function init() {
      hoist('.bxc-bottomnav');
      hoist('[data-bxc-sidebackdrop]');
      initRange();
      var c = gridEl();
      if (c && !c.dataset.bound) {
        c.dataset.bound = '1';
        lanes = [];
        c.querySelectorAll('[data-bxc-shelf]').forEach(function (el) {
          var row = el.querySelector('[data-bxc-row]');
          if (!row) return;
          lanes.push({ el: el, word: el.getAttribute('data-bxc-shelf'), row: row, cards: Array.prototype.slice.call(row.children) });
        });
      }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function(){
  function activate(root, key){
    var pills = root.querySelectorAll('[data-dbs-tab]');
    var panels = root.querySelectorAll('[data-dbs-panel]');
    Array.prototype.forEach.call(pills, function(p){
      var on = p.getAttribute('data-dbs-tab') === key;
      p.classList.toggle('is-active', on);
      p.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    Array.prototype.forEach.call(panels, function(pn){
      pn.classList.toggle('is-active', pn.getAttribute('data-dbs-panel') === key);
    });
  }
  function init(root){
    var roots = (root || document).querySelectorAll('.dbs');
    Array.prototype.forEach.call(roots, function(s){
      if(s.dataset.dbsInit === '1') return; s.dataset.dbsInit = '1';
      var pills = s.querySelectorAll('[data-dbs-tab]');
      Array.prototype.forEach.call(pills, function(p){
        p.addEventListener('click', function(){ activate(s, p.getAttribute('data-dbs-tab')); });
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  document.addEventListener('shopify:block:select', function(e){
    var root = e.target.closest && e.target.closest('.dbs'); if(!root) return;
    var key = e.target.getAttribute && e.target.getAttribute('data-dbs-tab');
    if(!key){ var el = e.target.querySelector && e.target.querySelector('[data-dbs-tab]'); if(el) key = el.getAttribute('data-dbs-tab'); }
    if(key) activate(root, key);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["farm-qty"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function parseMoney(str){
      if(!str){ return null; }
      var first = -1, last = -1, i, c;
      for(i = 0; i < str.length; i++){ c = str.charCodeAt(i); if(c >= 48 && c <= 57){ if(first < 0){ first = i; } last = i; } }
      if(first < 0){ return null; }
      var pre = str.slice(0, first);
      var suf = str.slice(last + 1);
      var mid = str.slice(first, last + 1);
      var hasDot = mid.indexOf('.') >= 0, hasComma = mid.indexOf(',') >= 0;
      var clean = '', dec = 0, seenDot = false, j, ch;
      for(j = 0; j < mid.length; j++){
        ch = mid.charAt(j);
        if(ch >= '0' && ch <= '9'){ clean += ch; if(seenDot){ dec++; } }
        else if(ch === '.'){ if(hasDot){ clean += '.'; seenDot = true; } }
        else if(ch === ','){ if(hasComma && !hasDot){ clean += '.'; seenDot = true; } }
      }
      var num = parseFloat(clean);
      if(isNaN(num)){ return null; }
      return { num: num, pre: pre, suf: suf, dec: dec };
    }
    function group(intStr){
      var out = '', c = 0, i;
      for(i = intStr.length - 1; i >= 0; i--){ out = intStr.charAt(i) + out; c++; if(c % 3 === 0 && i > 0){ out = ',' + out; } }
      return out;
    }
    function fmt(num, ref){
      var s = num.toFixed(ref.dec);
      var dot = s.indexOf('.');
      var ip = dot >= 0 ? s.slice(0, dot) : s;
      var fp = dot >= 0 ? s.slice(dot) : '';
      return ref.pre + group(ip) + fp + ref.suf;
    }
    function init(){
      var root = document.querySelector('[data-fqty]');
      if(!root){ return; }
      var info = document.querySelector('.bxp-info');
      if(info && root.parentNode !== info){
        var anchor = document.querySelector('.bxp-qty');
        if(anchor){ info.insertBefore(root, anchor); }
        else { var wa = info.querySelector('.bxp-wa'); if(wa){ info.insertBefore(root, wa); } else { info.appendChild(root); } }
      }
      var min = parseInt(root.getAttribute('data-min'), 10) || 1;
      var vid = root.getAttribute('data-vid');
      var input = root.querySelector('[data-fqty-input]');
      var totalEl = root.querySelector('[data-fqty-total]');
      var srcEl = root.querySelector('[data-fqty-unit]');
      var addBtn = root.querySelector('[data-fqty-add]');
      var qty = min;
      function unitText(){
        var n = document.querySelector('[data-bxp-now]');
        if(n){ var t = (n.textContent || '').trim(); if(t){ return t; } }
        if(srcEl){ return (srcEl.textContent || '').trim(); }
        return '';
      }
      function render(){
        if(input){ input.value = qty; }
        if(totalEl){
          var ref = parseMoney(unitText());
          if(ref){ totalEl.textContent = fmt(ref.num * qty, ref); }
        }
      }
      function setQty(n){ if(isNaN(n) || n < min){ n = min; } qty = Math.floor(n); render(); }
      root.addEventListener('click', function(e){
        if(e.target.closest('[data-fqty-minus]')){ setQty(qty - 1); }
        else if(e.target.closest('[data-fqty-plus]')){ setQty(qty + 1); }
        else if(e.target.closest('[data-fqty-buy]')){ go(true); }
        else if(e.target.closest('[data-fqty-add]')){ go(false); }
      });
      if(input){
        input.addEventListener('change', function(){ setQty(parseInt(input.value, 10)); });
        input.addEventListener('blur', function(){ setQty(parseInt(input.value, 10)); });
      }
      function go(checkout){
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] }) })
        .then(function(r){ if(!r.ok){ throw new Error('add'); } return r.json(); })
        .then(function(){ if(checkout){ window.location.href = '/checkout'; } else { if(addBtn){ addBtn.classList.add('is-done'); setTimeout(function(){ addBtn.classList.remove('is-done'); }, 1200); } document.dispatchEvent(new CustomEvent('bxc:cart-updated')); } })
        .catch(function(){});
      }
      var watch = document.querySelector('[data-bxp-now]') || srcEl;
      if(watch && typeof MutationObserver !== 'undefined'){
        var mo = new MutationObserver(function(){ render(); });
        mo.observe(watch, { childList: true, subtree: true, characterData: true });
      }
      render();
      setTimeout(render, 400);
      setTimeout(render, 1200);
    }
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();
  (function(){
    function initBogo(){
      var b = document.querySelector('[data-bxgo]');
      if(!b){ return; }
      var info = document.querySelector('.bxp-info');
      if(info && b.parentNode !== info){
        var anchor = document.querySelector('.bxp-qty') || document.querySelector('.bxp-ctas');
        if(anchor){ info.insertBefore(b, anchor); } else { info.appendChild(b); }
      }
    }
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initBogo); } else { initBogo(); }
    document.addEventListener('shopify:section:load', initBogo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-receive"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var sections=(root||document).querySelectorAll('.zilzal-htr');
    Array.prototype.forEach.call(sections,function(s){
      if(s.dataset.htrInit==='1') return; s.dataset.htrInit='1';
      var cards=s.querySelectorAll('.zilzal-htr__card');
      if(!cards.length) return;
      var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      if(reduce || !('IntersectionObserver' in window)) return;
      s.classList.add('htr-anim');
      var io=new IntersectionObserver(function(en){en.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });},{threshold:0.15});
      Array.prototype.forEach.call(cards,function(c,i){ c.style.transitionDelay=(i*0.09)+'s'; io.observe(c); });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-blocks"] && !Shopify.designMode) return;
  try {
    
(function(){
  function openModal(m){ m.classList.add('is-open'); m.setAttribute('aria-hidden','false'); document.body.classList.add('zh-noscroll'); }
  function closeModal(m){ m.classList.remove('is-open'); m.setAttribute('aria-hidden','true'); document.body.classList.remove('zh-noscroll'); }
  function bindModal(m){
    var overlay=m.querySelector('[data-zh-modal-overlay]');
    var panel=m.querySelector('[data-zh-modal-panel]');
    var closeBtn=m.querySelector('[data-zh-modal-close]');
    if(overlay) overlay.addEventListener('click',function(){ closeModal(m); });
    if(closeBtn) closeBtn.addEventListener('click',function(){ closeModal(m); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape' && m.classList.contains('is-open')) closeModal(m); });
    if(panel){
      var sy=0, touching=false, atTop=true;
      panel.addEventListener('touchstart',function(e){ touching=true; sy=e.touches[0].clientY; atTop=(panel.scrollTop<=0); panel.style.transition='none'; },{passive:true});
      panel.addEventListener('touchmove',function(e){ if(!touching||!atTop) return; var dy=e.touches[0].clientY-sy; if(dy>0) panel.style.transform='translateY('+dy+'px)'; },{passive:true});
      panel.addEventListener('touchend',function(e){ if(!touching) return; touching=false; panel.style.transition=''; var dy=e.changedTouches[0].clientY-sy; panel.style.transform=''; if(atTop && dy>100) closeModal(m); },{passive:true});
    }
  }
  function initModals(root){
    var modals=(root||document).querySelectorAll('.zilzal-hero-wrapper [data-zh-modal]');
    Array.prototype.forEach.call(modals,function(modal){
      var sid=modal.getAttribute('data-zh-sid');
      var stale=document.querySelectorAll('body > [data-zh-modal][data-zh-sid="'+sid+'"]');
      Array.prototype.forEach.call(stale,function(x){ if(x!==modal && x.parentNode) x.parentNode.removeChild(x); });
      if(modal.parentNode!==document.body){ document.body.appendChild(modal); }
      if(modal.dataset.zhBound!=='1'){ modal.dataset.zhBound='1'; bindModal(modal); }
    });
    var triggers=(root||document).querySelectorAll('[data-zh-open-modal]');
    Array.prototype.forEach.call(triggers,function(t){
      if(t.dataset.zhBound==='1') return; t.dataset.zhBound='1';
      t.addEventListener('click',function(e){ e.preventDefault(); var sid=t.getAttribute('data-zh-target'); var m=document.querySelector('[data-zh-modal][data-zh-sid="'+sid+'"]'); if(m) openModal(m); });
    });
  }
  function animateCount(el){
    if(el.dataset.zhCounted==='1') return; var orig=(el.textContent||'').trim(); var mm=orig.match(/(\D*)([\d,]+)(.*)/); if(!mm) return;
    var target=parseInt(mm[2].replace(/,/g,''),10); if(isNaN(target)) return; el.dataset.zhCounted='1'; var pre=mm[1]||'', suf=mm[3]||'';
    if(window.matchMedia('(prefers-reduced-motion:reduce)').matches){el.textContent=pre+target.toLocaleString()+suf;return;}
    var dur=1600,t0=null; function frame(now){if(t0===null)t0=now;var p=Math.min((now-t0)/dur,1),e=1-Math.pow(1-p,3);el.textContent=pre+Math.round(e*target).toLocaleString()+suf;if(p<1)requestAnimationFrame(frame);} requestAnimationFrame(frame);
  }
  function initCounts(root){ var els=(root||document).querySelectorAll('.zilzal-hero-wrapper [data-zh-count]'); if(!els.length) return; if(!('IntersectionObserver' in window)){Array.prototype.forEach.call(els,animateCount);return;} var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){animateCount(e.target);io.unobserve(e.target);}});},{threshold:0.6}); Array.prototype.forEach.call(els,function(x){io.observe(x);}); }
  function initCarousels(root){
    var nodes=(root||document).querySelectorAll('.zilzal-hero-wrapper [data-zh-carousel]');
    Array.prototype.forEach.call(nodes,function(c){
      if(c.dataset.zhInit==='true') return; c.dataset.zhInit='true';
      var track=c.querySelector('[data-zh-track]'); if(!track) return;
      var cards=Array.prototype.slice.call(track.querySelectorAll('[data-zh-card]'));
      var n=cards.length; if(n===0) return;
      var speed=parseInt(c.dataset.speed,10)||3000;
      var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      var active=0,timer=null;
      function visCount(){var w=c.clientWidth||800;return w<480?1:2;}
      function layout(){
        var vis=visCount(),cw=cards[0].offsetWidth||220,half=Math.floor(n/2);
        for(var i=0;i<n;i++){
          var off=i-active; while(off>half)off-=n; while(off<-half)off+=n;
          var a=Math.abs(off),card=cards[i];
          if(a>vis){card.style.opacity='0';card.style.pointerEvents='none';card.style.transform='translate(-50%,-50%) translateZ(-520px) scale(0.4)';card.style.zIndex='0';card.classList.remove('is-active');card.setAttribute('aria-hidden','true');continue;}
          var x=off*cw*0.5,z=-a*90,rot=off*-22,sc=Math.max(0.9-0.12*a,0.55);
          card.style.transform='translate(-50%,-50%) translateX('+x+'px) translateZ('+z+'px) rotateY('+rot+'deg) scale('+sc+')';
          card.style.opacity=a===0?'1':String(Math.max(0.9-0.24*(a-1),0.35));
          card.style.zIndex=String(100-a); card.style.pointerEvents='auto';
          var isC=off===0; card.classList.toggle('is-active',isC); card.setAttribute('aria-hidden',isC?'false':'true');
        }
      }
      function setActive(i){active=((i%n)+n)%n;layout();}
      function next(){setActive(active+1);} function prev(){setActive(active-1);}
      function start(){if(reduce||timer||n<2)return;timer=setInterval(next,speed);}
      function stop(){if(timer){clearInterval(timer);timer=null;}}
      var navScope=c.parentElement||c;
      Array.prototype.forEach.call(navScope.querySelectorAll('[data-zh-prev]'),function(b){b.addEventListener('click',function(e){e.preventDefault();prev();});});
      Array.prototype.forEach.call(navScope.querySelectorAll('[data-zh-next]'),function(b){b.addEventListener('click',function(e){e.preventDefault();next();});});
      var dn=false,sx=0,mv=false,swiped=false;
      function pD(e){dn=true;mv=false;sx=(e.touches?e.touches[0].clientX:e.clientX);stop();}
      function pM(e){if(!dn)return;if(Math.abs((e.touches?e.touches[0].clientX:e.clientX)-sx)>8)mv=true;}
      function pU(e){if(!dn)return;dn=false;var x=(e.changedTouches?e.changedTouches[0].clientX:e.clientX);if(Math.abs(x-sx)>40){swiped=true;if(x-sx<0)next();else prev();}start();}
      c.addEventListener('mousedown',pD);window.addEventListener('mousemove',pM);window.addEventListener('mouseup',pU);
      c.addEventListener('touchstart',pD,{passive:true});c.addEventListener('touchmove',pM,{passive:true});c.addEventListener('touchend',pU);
      function doAdd(ab){ var id=ab.getAttribute('data-variant-id'); if(!id) return; var lbl=ab.textContent; ab.setAttribute('disabled','disabled'); ab.textContent='...'; fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})}).then(function(r){if(!r.ok)throw new Error();return r.json();}).then(function(){window.location.href='/cart';}).catch(function(){ab.removeAttribute('disabled');ab.textContent=lbl;}); }
      // --- Carousel card clicks (Steps 1-4) ---
      cards.forEach(function(card,i){
        card.addEventListener('click',function(e){
          if(swiped){swiped=false;e.preventDefault();return;} // a real swipe just happened; swallow its trailing click (no navigation)
          // Step 2: is this the center (active) card?
          if(card.classList.contains('is-active')){
            // Step 4: yes -> let it behave normally (open product link; trigger add-to-cart button which has no default)
            var ab=e.target.closest('[data-zh-add]');
            if(ab){e.preventDefault();doAdd(ab);}
            return;
          }
          // Step 3: no (side card) -> stop the link and slide this card to the center
          e.preventDefault();
          setActive(i);
        });
      });
      c.addEventListener('mouseenter',stop);c.addEventListener('mouseleave',start);
      document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else start();});
      window.addEventListener('resize',layout);
      layout();start();
    });
  }
  function init(){ initCounts(document); initCarousels(document); initModals(document); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bxc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var VD = [];
    var qty = 1;
    function hoist(sel) {
      var els = Array.prototype.slice.call(document.querySelectorAll(sel));
      if (!els.length) return;
      var keep = null;
      els.forEach(function (el) { if (!el.hasAttribute('data-bxp-moved')) keep = el; });
      if (!keep) keep = els[0];
      els.forEach(function (el) { if (el !== keep && el.parentNode) el.parentNode.removeChild(el); });
      keep.setAttribute('data-bxp-moved', '1');
      if (keep.parentNode !== document.body) document.body.appendChild(keep);
    }
    function readVariants() {
      var el = document.querySelector('[data-bxp-vdata]');
      if (!el) return;
      try { VD = JSON.parse(el.textContent); } catch (e) { VD = []; }
    }
    function setQty(n) {
      qty = n < 1 ? 1 : n;
      document.querySelectorAll('[data-bxp-qval]').forEach(function (x) { x.textContent = qty; });
    }
    function applyVariant(vid) {
      var d = null;
      VD.forEach(function (x) { if (String(x.id) === String(vid)) d = x; });
      if (!d) return;
      document.querySelectorAll('[data-bxp-now]').forEach(function (n) { n.textContent = d.n; });
      document.querySelectorAll('[data-bxp-was]').forEach(function (w) { if (d.w) { w.textContent = d.w; w.hidden = false; } else { w.hidden = true; } });
      document.querySelectorAll('[data-bxp-disc]').forEach(function (p) { if (d.p > 0) { p.textContent = d.p + '% خصم'; p.hidden = false; } else { p.hidden = true; } });
      document.querySelectorAll('[data-bxp-add], [data-bxp-buynow]').forEach(function (b) { b.setAttribute('data-vid', d.id); b.disabled = !d.a; b.classList.toggle('is-disabled', !d.a); });
    }
    function postAdd(vid) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
    }
    document.addEventListener('click', function (e) {
      var qm = e.target.closest('[data-bxp-qminus]');
      if (qm) { setQty(qty - 1); return; }
      var qp = e.target.closest('[data-bxp-qplus]');
      if (qp) { setQty(qty + 1); return; }
      var t = e.target.closest('[data-bxp-thumb]');
      if (t) { var main = document.querySelector('[data-bxp-main]'); if (main) main.src = t.getAttribute('data-src'); document.querySelectorAll('[data-bxp-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === t); }); return; }
      var a = e.target.closest('[data-bxp-add]');
      if (a && !a.disabled) {
        if (a.classList.contains('is-loading') || a.classList.contains('is-done')) return;
        var avid = a.getAttribute('data-vid'); if (!avid) return;
        a.classList.add('is-loading');
        postAdd(avid).then(function () {
          a.classList.remove('is-loading'); a.classList.add('is-done');
          setTimeout(function () { a.classList.remove('is-done'); }, 1200);
          document.dispatchEvent(new CustomEvent('bxc:cart-updated'));
        }).catch(function () { a.classList.remove('is-loading'); });
        return;
      }
      var bn = e.target.closest('[data-bxp-buynow]');
      if (bn && !bn.disabled) {
        if (bn.classList.contains('is-loading')) return;
        var bvid = bn.getAttribute('data-vid'); if (!bvid) return;
        bn.classList.add('is-loading');
        postAdd(bvid).then(function () { window.location.href = '/checkout'; }).catch(function () { bn.classList.remove('is-loading'); });
        return;
      }
    });
    document.addEventListener('change', function (e) {
      var s = e.target.closest('[data-bxp-variant]');
      if (s) applyVariant(s.value);
    });
    function init() { readVariants(); setQty(1); hoist('[data-bxp-stickybar]'); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
